import React from 'react';
import { Switch } from 'react-router-dom';
import ProtectedRoute from '../../utils/ProtectedRoute';
import { usePermissions } from '@/providers/Permissions.provider';
import { usePartnerData } from '@/providers/PartnerData.provider';
import PartnerCreationPage from './PartnerCreation/PartnerCreationPage';
import PartnerList from './PartnerList/PartnerList';
import PartnerDetailsPage from './PartnerDetails/PartnerDetailsPage';

const Routes = (): React.JSX.Element => {
  const { permissions } = usePermissions();
  const {
    response: { isRoleAdmin },
  } = usePartnerData();
  const isAllowed = isRoleAdmin && permissions.PartnerCreationEnabled;

  return (
    <Switch>
      <ProtectedRoute isAllowed={isAllowed} showPermission exact path="/partners-create">
        <PartnerCreationPage />
      </ProtectedRoute>
      <ProtectedRoute isAllowed={isAllowed} showPermission exact path="/partners">
        <PartnerList />
      </ProtectedRoute>
      <ProtectedRoute isAllowed={isAllowed} showPermission path="/partners/:partnerAccountId">
        <PartnerDetailsPage />
      </ProtectedRoute>
    </Switch>
  );
};

export default Routes;
